import {
    Lozenge,
    LozengeAppearance
} from "@/libraries/design/components/lozenge/src/lozenge.tsx";

export interface StatusLozengeProps {
    text: string;
}

export type Status = "future" | "coming soon" | "released" | "completed";

export const StatusLozenge = (props: StatusLozengeProps) => {
    const statusColor = getStatusColor(props.text.toLowerCase() as Status);
    return <Lozenge text={props.text} appearance={statusColor} />;
};

const getStatusColor = (status: Status) => {
    let statusColor: LozengeAppearance = "neutral";
    if (status === "future") {
        statusColor = "purple";
    }
    if (status === "coming soon") {
        statusColor = "yellow";
    }
    if (status === "released") {
        statusColor = "lime";
    }
    if (status === "completed") {
        statusColor = "neutral";
    }
    return statusColor;
};
